import { useRequestAction } from '../../../Hooks/Features/RequestAction/useRequestAction';

const RequestAction = () => {


    const { message } = useRequestAction();

    return (
        <div style={{ height: "100vh" }}>
            <div class="timesheet-approve">
                <div class="w50 card shadow-lg rounded-4">
                    <div class="header">
                        <div class="d-flex justify-content-between align-items-center p-4">
                            <div class="logo">
                                <img
                                    src="./assets/logo-white-1.png"
                                    alt="SRKay Consulting Group Logo"
                                    width={110}
                                    height={30}
                                />
                            </div>
                            <div class="text-white fw-semibold fs-3">SRKay Insights</div>
                        </div>
                    </div>
                    <div class="card-body border-bottom text-capitalize">
                        <h2 className={`text-center text-${message?.color}`} >   {message?.msg}</h2>
                    </div>
                    <div class="footer text-center">
                        <div class="py-3">
                            <a href="https://insights.srkay.com/" rel="noopener"
                                class="fw-semibold text-decoration-none text-primary">Login to SRKay</a>
                        </div>
                        <div class="pb-2">
                            <span class="fst-italic text-muted">Need help or facing any issue? Write to us at
                                <a href="mailto:insights.support@srkay.com" class="fw-semibold text-primary">insights.support@srkay.com</a>
                            </span>
                        </div>
                        <div class="f-row-3 text-muted">
                            <span>Copyright 2025 by SRKay Consulting Group · www.srkay.com</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RequestAction